import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  // https://ebdc.ssipac.suqian.gov.cn:8001/mainLogin  支付宝跳转路径
  // base: "/suqian8app/",   // 测试服务器8
  routes: [
    {
      path: "/",
      name: "error",
      component: resolve => require(["@/components/error.vue"], resolve)
    },
    /* {
    path: '/',
    name: '登录',
    component: resolve => require(['@/components/login.vue'], resolve)
  }, */
    {
      path: "/Phone",
      name: "登录",
      component: resolve => require(["@/components/login.vue"], resolve)
    },
    /* {
    path: '/sqPage1',
    name: 'sqPage1',
    component: resolve => require(['@/components/sqPage1.vue'], resolve),
    meta: {
      title: '个人信息授权'
    }
  },
  {
    path: '/sqPage2',
    name: 'sqPage2',
    component: resolve => require(['@/components/sqPage2.vue'], resolve),
    meta: {
      title: '手机登录'
    }
  },
  {
    path: '/sqPage3',
    name: 'sqPage3',
    component: resolve => require(['@/components/sqPage3.vue'], resolve),
    meta: {
      title: '人脸认证'
    }
  }, */
    {
      path: "/weixinMini",
      name: "weixinMini",
      component: resolve => require(["@/components/weixinMini.vue"], resolve),
      meta: {
        title: "小程序登录"
      }
    },
    /* {
    path: '/wechatLogin',
    name: 'wechatLogin',
    component: resolve => require(['@/components/wechatlogin.vue'], resolve),
    meta: {
      title: '实名认证'
    }
  }, {
    path: '/wechatFace',
    name: 'wechatFace',
    component: resolve => require(['@/components/wechatFace.vue'], resolve),
    meta: {
      title: '微信刷脸登录'
    }
  }, {
    path: '/appIndex',
    name: 'appIndex',
    component: resolve => require(['@/components/alipayIndex.vue'], resolve),
    meta: {
      title: 'app登录'
    }
  }, {
    path: '/alipayLogin',
    name: 'alipayLogin',
    component: resolve => require(['@/components/alipayIndex.vue'], resolve),
    meta: {
      title: '扫脸认证'
    }
  }, */
    {
      path: "/authorMsg",
      name: "authorMsg",
      component: resolve => require(["@/components/authorMsg.vue"], resolve),
      meta: {
        title: "授权失败"
      }
    },
    {
      path: "/authorFace",
      name: "authorFace",
      component: resolve => require(["@/components/authorFace.vue"], resolve),
      meta: {
        title: "功能刷脸"
      }
    },
    // {
    //   path: '/main',
    //   name: 'main',
    //   component: resolve => require(['@/components/index.vue'], resolve),
    //   meta: {
    //     title: '苏宿园区不动产'
    //   }
    // },
    {
      path: "/main",
      name: "Layout",
      component: resolve => require(["@/components/Layout/index.vue"], resolve),
      meta: {
        title: "苏宿园区不动产"
      }
    },
    {
      path: "/mainLogin&chInfo=ch_alipaysearch__chsub_normal",
      name: "/mainLogin&chInfo=ch_alipaysearch__chsub_normal",
      component: resolve =>
        require(["@/components/newLayout/newlayout.vue"], resolve),
      meta: {
        title: "苏宿园区不动产"
      }
    },
    {
      path: "/mainLogin",
      name: "Layout",
      component: resolve =>
        require(["@/components/newLayout/newlayout.vue"], resolve),
      meta: {
        title: "苏宿园区不动产"
      }
    },
    {
      path: "/indexLoginByToken",
      name: "indexLoginByToken",
      component: resolve =>
        require(["@/components/indexLoginByToken.vue"], resolve),
      meta: {
        title: "苏宿园区不动产"
      }
    },
    {
      path: "/appointment/index",
      name: "/appointment/index",
      component: resolve =>
        require(["@/components/appointment/index.vue"], resolve),
      meta: {
        title: "在线预约"
      }
    },
    /* 我要预约 */
    {
      path: "/appointment/yyxz",
      name: "/appointment/yyxz",
      component: resolve =>
        require(["@/components/appointment/yyxz.vue"], resolve),
      meta: {
        title: "不动产登记预约服务"
      }
    },
    {
      path: "/appointment/choice",
      name: "/appointment/choice",
      component: resolve =>
        require(["@/components/appointment/choice.vue"], resolve),
      meta: {
        title: "不动产登记预约服务"
      }
    },
    {
      path: "/appointment/choicebdc",
      name: "/appointment/choicebdc",
      component: resolve =>
        require(["@/components/appointment/choicebdc.vue"], resolve),
      meta: {
        title: "不动产选择"
      }
    },
    {
      path: "/appointment/importMsg",
      name: "/appointment/importMsg",
      component: resolve =>
        require(["@/components/appointment/importMsg.vue"], resolve),
      meta: {
        title: "填写预约信息"
      }
    },
    {
      path: "/appointment/yycg",
      name: "/appointment/yycg",
      component: resolve =>
        require(["@/components/appointment/yycg.vue"], resolve),
      meta: {
        title: "预约成功"
      }
    },
    /* 我的预约 */
    {
      path: "/appointment/record",
      name: "/appointment/record",
      component: resolve =>
        require(["@/components/appointment/record.vue"], resolve),
      meta: {
        title: "预约查询"
      }
    },
    {
      path: "/appointment/yyxxMsg",
      name: "/appointment/yyxxMsg",
      component: resolve =>
        require(["@/components/appointment/yyxxMsg.vue"], resolve),
      meta: {
        title: "查询信息"
      }
    },
    {
      path: "/appointment/evaluate1",
      name: "/appointment/evaluate1",
      component: resolve =>
        require(["@/components/appointment/evaluate1.vue"], resolve),
      meta: {
        title: "预约评价"
      }
    },
    {
      path: "/appointment/seeevaluate",
      name: "/appointment/seeevaluate",
      component: resolve =>
        require(["@/components/appointment/seeevaluate.vue"], resolve),
      meta: {
        title: "查看评价"
      }
    },
    // 查询---我的房产
    {
      path: "/query/index",
      name: "/query/index",
      component: resolve => require(["@/components/query/index.vue"], resolve),
      meta: {
        title: "查询服务"
      }
    },
    {
      path: "/query/mine",
      name: "/query/mine",
      component: resolve => require(["@/components/query/mine.vue"], resolve),
      meta: {
        title: "我的不动产"
      }
    },
    {
      path: "/query/otherone/otherone",
      name: "/query/otherone/otherone",
      component: resolve =>
        require(["@/components/query/otherone/otherone.vue"], resolve),
      meta: {
        title: "他人房产"
      }
    },
    {
      path: "/query/otherone/otherbdcxx",
      name: "/query/otherone/otherbdcxx",
      component: resolve =>
        require(["@/components/query/otherone/otherbdcxx.vue"], resolve),
      meta: {
        title: "房产信息"
      }
    },
    {
      path: "/query/studyLocate/inputMsg",
      name: "query/studyLocate/inputMsg",
      component: resolve =>
        require(["@/components/query/locate/inputMsg.vue"], resolve),
      meta: {
        title: "学位查询"
      }
    },
    {
      path: "/query/studyLocate/detail",
      name: "/query/studyLocate/detail",
      component: resolve =>
        require(["@/components/query/locate/detail.vue"], resolve),
      meta: {
        title: "学位信息"
      }
    },

    {
      path: "/query/studyLocate/xwcx",
      name: "/query/studyLocate/xwcx",
      component: resolve =>
        require(["@/components/query/locate/xwcx.vue"], resolve),
      meta: {
        title: "学位查询"
      }
    },
    {
      path: "/query/studyLocate/confirmList",
      name: "/query/studyLocate/confirmList",
      component: resolve =>
        require(["@/components/query/locate/confirmList.vue"], resolve),
      meta: {
        title: "学生列表"
      }
    },

    {
      path: "/query/studyLocate/parentsConfirm",
      name: "/query/studyLocate/parentsConfirm",
      component: resolve =>
        require(["@/components/query/locate/paentsInputMsg.vue"], resolve),
      meta: {
        title: "家长确认"
      }
    },
    {
      path: "/query/studyLocate/parentConfirmDetail",
      name: "/query/studyLocate/parentConfirmDetail",
      component: resolve =>
        require(["@/components/query/locate/parentConfirmDetail.vue"], resolve),
      meta: {
        title: "确认信息"
      }
    },

    {
      path: "/query/djjd/djfcx",
      name: "/query/djjd/djfcx",
      component: resolve =>
        require(["@/components/query/djjd/djfcx.vue"], resolve),
      meta: {
        title: "登记进度"
      }
    },
    {
      path: "/query/djjd/djfxx",
      name: "/query/djjd/djfxx",
      component: resolve =>
        require(["@/components/query/djjd/djfxx.vue"], resolve),
      meta: {
        title: "查询结果"
      }
    },
    {
      path: "/query/djjd/djfxx",
      name: "/query/djjd/djfxx",
      component: resolve =>
        require(["@/components/query/djjd/djfxx.vue"], resolve),
      meta: {
        title: "办理进度"
      }
    },
    {
      path: "/query/wtcx/wtcx",
      name: "/query/wtcx/wtcx",
      component: resolve =>
        require(["@/components/query/wtcx/wtcx.vue"], resolve),
      meta: {
        title: "委托查询"
      }
    },
    {
      path: "/query/wtcx/entrust",
      name: "/query/wtcx/entrust",
      component: resolve =>
        require(["@/components/query/wtcx/entrust.vue"], resolve),
      meta: {
        title: "选择不动产"
      }
    },
    {
      path: "/query/wtcx/fillEntrust",
      name: "/query/wtcx/fillEntrust",
      component: resolve =>
        require(["@/components/query/wtcx/fillEntrust.vue"], resolve),
      meta: {
        title: "填写信息"
      }
    },
    {
      path: "/query/wtcx/wtsqcg",
      name: "/query/wtcx/wtsqcg",
      component: resolve =>
        require(["@/components/query/wtcx/wtsqcg.vue"], resolve),
      meta: {
        title: "申请结果"
      }
    },
    {
      path: "/query/wtcx/entrustList",
      name: "/query/wtcx/entrustList",
      component: resolve =>
        require(["@/components/query/wtcx/entrustList.vue"], resolve),
      meta: {
        title: "我的委托"
      }
    },
    {
      path: "/query/wtcx/searchEntrust",
      name: "/query/wtcx/searchEntrust",
      component: resolve =>
        require(["@/components/query/wtcx/searchEntrust.vue"], resolve),
      meta: {
        title: "委托查询"
      }
    },
    {
      path: "/query/wtcx/viewEntrust",
      name: "/query/wtcx/viewEntrust",
      component: resolve =>
        require(["@/components/query/wtcx/viewEntrust.vue"], resolve),
      meta: {
        title: "查看委托"
      }
    },
    {
      path: "/query/yzjy/yzjy",
      name: "/query/yzjy/yzjy",
      component: resolve =>
        require(["@/components/query/yzjy/yzjy.vue"], resolve),
      meta: {
        title: "业主校验"
      }
    },
    {
      path: "/query/intermediarycredit",
      name: "/query/intermediarycredit",
      component: resolve =>
        require(["@/components/query/intermediaryCredit/index.vue"], resolve),
      meta: {
        title: "中介信用"
      }
    },
    {
      path: "/query/agencydetail",
      name: "/query/agencydetail",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/agencyDetail.vue"
        ], resolve),
      meta: {
        title: "基本信息"
      }
    },
    {
      path: "/query/pcidetail",
      name: "/query/pcidetail",
      component: resolve =>
        require(["@/components/query/owner/picDetail.vue"], resolve),
      meta: {
        title: "图片详情"
      }
    },
    {
      path: "/query/evaluation-mediation",
      name: "evaluationOfMediation",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/evaluationOfMediation.vue"
        ], resolve),
      meta: {
        title: "评价中介"
      }
    },
    {
      path: "/query/toviewmore",
      name: "/query/toviewmore",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/toViewMore.vue"
        ], resolve),
      meta: {
        title: "经纪人"
      }
    },
    {
      path: "/query/brokerdetails",
      name: "/query/brokerdetails",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/brokerDetails.vue"
        ], resolve),
      meta: {
        title: "经纪人详情"
      }
    },
    {
      path: "/query/evaluationdetails",
      name: "/query/evaluationdetails",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/evaluationDetails.vue"
        ], resolve),
      meta: {
        title: "评价详情"
      }
    },
    {
      path: "/query/assetsmap",
      name: "/query/assetsmap",
      component: resolve =>
        require(["@/components/query/intermediaryCredit/map.vue"], resolve),
      meta: {
        title: "导航"
      }
    },
    {
      path: "/query/evaluation",
      name: "/query/evaluation",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/evaluation.vue"
        ], resolve),
      meta: {
        title: "评价"
      }
    },
    {
      path: "/query/owner/agencydetail",
      name: "/query/owner/agencydetail",
      component: resolve =>
        require(["@/components/query/owner/agencyDetail.vue"], resolve),
      meta: {
        title: "企业信用"
      }
    },
    {
      path: "/query/search",
      name: "/query/search",
      component: resolve =>
        require(["@/components/query/owner/search.vue"], resolve),
      meta: {
        title: "从业主体"
      }
    },
    {
      path: "/query/owner/toviewmore",
      name: "/query/owner/toviewmore",
      component: resolve =>
        require(["@/components/query/owner/toViewMore.vue"], resolve),
      meta: {
        title: "从业人员"
      }
    },

    {
      path: "/query/owner/brokerdetails",
      name: "/query/owner/brokerdetails",
      component: resolve =>
        require(["@/components/query/owner/brokerDetails.vue"], resolve),
      meta: {
        title: "从业人员详细信息"
      }
    },

    {
      path: "/query/owner/evaluationdetails",
      name: "/query/owner/evaluationdetails",
      component: resolve =>
        require(["@/components/query/owner/evaluationDetails.vue"], resolve),
      meta: {
        title: "客户评价"
      }
    },

    {
      path: "/query/owner/evaluation",
      name: "/query/owner/evaluation",
      component: resolve =>
        require(["@/components/query/owner/evaluation.vue"], resolve),
      meta: {
        title: "评价从业人员"
      }
    },
    {
      path: "/query/owner/myfavorite",
      name: "/query/owner/myfavorite",
      component: resolve =>
        require(["@/components/query/owner/myFavorite.vue"], resolve),
      meta: {
        title: "我的收藏"
      }
    },
    {
      path: "/query/property",
      name: "/query/property",
      component: resolve =>
        require(["@/components/query/propertyManagement/index.vue"], resolve),
      meta: {
        title: "我的小区"
      }
    },
    {
      path: "/query/intellectualproperty",
      name: "/query/intellectualproperty",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/intellectualProperty.vue"
        ], resolve),
      meta: {
        title: "智慧物业"
      }
    },
    {
      path: "/query/housekeeperList",
      name: "/query/housekeeperList",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/housekeeperList.vue"
        ], resolve),
      meta: {
        title: "找管家"
      }
    },
    {
      path: "/query/announcementsdetail",
      name: "/query/announcementsdetail",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/announcementsDetail.vue"
        ], resolve),
      meta: {
        title: "通知公告详情"
      }
    },
    {
      path: "/query/industryAuthority",
      name: "/query/industryAuthority",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/industryAuthority.vue"
        ], resolve),
      meta: {
        title: "业委会"
      }
    },
    {
      path: "/query/industryAuthorityDetails",
      name: "/query/industryAuthorityDetails",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/industryAuthorityDetails.vue"
        ], resolve),
      meta: {
        title: "业委会"
      }
    },
    {
      path: "/query/evaluate",
      name: "/query/evaluate",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/evaluate.vue"
        ], resolve),
      meta: {
        title: "业委会"
      }
    },
    {
      path: "/query/maintenanceFunds",
      name: "/query/maintenanceFunds",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/maintenanceFunds.vue"
        ], resolve),
      meta: {
        title: "维修资金"
      }
    },
    {
      path: "/query/reportAboutTheRepair",
      name: "/query/reportAboutTheRepair",
      component: resolve =>
        require([
          "@/components/query/propertyManagement/reportAboutTheRepair.vue"
        ], resolve),
      meta: {
        title: "报事报修"
      }
    },
    {
      path: "/query/myfavorite",
      name: "/query/myfavorite",
      component: resolve =>
        require([
          "@/components/query/intermediaryCredit/myFavorite.vue"
        ], resolve),
      meta: {
        title: "我的收藏"
      }
    },
    {
      path: "/query/wsxxcx",
      name: "/query/wsxxcx",
      component: resolve =>
        require(["@/components/query/wsInfo/wsxxcx.vue"], resolve),
      meta: {
        title: "完税信息查询"
      }
    },

    {
      path: "/query/wsxxcx/wsxx",
      name: "/query/wsxxcx/wsxx",
      component: resolve =>
        require(["@/components/query/wsInfo/wsxx.vue"], resolve),
      meta: {
        title: "完税信息"
      }
    },
    {
      path: "/query/wsxxcx/wsxxfjcx",
      name: "/query/wsxxcx/wsxxfjcx",
      component: resolve =>
        require(["@/components/query/wsInfo/wsxxfjcx.vue"], resolve),
      meta: {
        title: "完税信息附件"
      }
    },

    {
      path: "/user/index",
      name: "/user/index",
      component: resolve => require(["@/components/user/index.vue"], resolve),
      meta: {
        title: "个人中心"
      }
    },
    {
      path: "/user/business",
      name: "/user/business",
      component: resolve =>
        require(["@/components/user/business.vue"], resolve),
      meta: {
        title: "我的业务"
      }
    },
    {
      path: "/user/yjghchoice",
      name: "/user/yjghchoice",
      component: resolve =>
        require(["@/components/user/yjghchoice.vue"], resolve),
      meta: {
        title: "一键过户"
      }
    },
    {
      path: "/detaileMsg",
      name: "/detaileMsg",
      component: resolve => require(["@/components/detaileMsg.vue"], resolve),
      meta: {
        title: "通知公告"
      }
    },
    {
      path: "/user/message",
      name: "/user/message",
      component: resolve => require(["@/components/user/message.vue"], resolve),
      meta: {
        title: "消息通知"
      }
    },
    {
      path: "/user/detaileMsg",
      name: "/user/detaileMsg",
      component: resolve =>
        require(["@/components/user/detaileMsg.vue"], resolve),
      meta: {
        title: "消息详情"
      }
    },
    {
      path: "/user/FAQ",
      name: "/user/FAQ",
      component: resolve => require(["@/components/user/FAQ.vue"], resolve),
      meta: {
        title: "服务中心"
      }
    },
    {
      path: "/user/about",
      name: "/user/about",
      component: resolve => require(["@/components/user/about.vue"], resolve),
      meta: {
        title: "关于"
      }
    },
    {
      path: "/user/ad_detail",
      name: "/user/ad_detail",
      component: resolve =>
        require(["@/components/user/ad_detail.vue"], resolve),
      meta: {
        title: "温馨提示"
      }
    },
    {
      path: "/user/temp_upload",
      name: "/user/temp_upload",
      component: resolve =>
        require(["@/components/user/temp_upload.vue"], resolve),
      meta: {
        title: "健康打卡"
      }
    },
    {
      path: "/user/temp_log",
      name: "/user/temp_log",
      component: resolve =>
        require(["@/components/user/temp_log.vue"], resolve),
      meta: {
        title: "打卡记录"
      }
    },
    {
      path: "/user/com_log",
      name: "/user/com_log",
      component: resolve => require(["@/components/user/com_log"], resolve),
      meta: {
        title: "今日体温报告"
      }
    },
    //意见反馈
    {
      path: "/user/feedback",
      name: "/user/feedback",
      component: resolve => require(["@/components/user/feedback"], resolve),
      meta: {
        title: "意见反馈"
      }
    },
    //体温申报
    {
      path: "/temperature/index",
      name: "/temperature/index",
      component: resolve =>
        require(["@/components/temperature/index"], resolve),
      meta: {
        title: "体温申报"
      }
    },
    //体温申报成功
    {
      path: "/temperature/success",
      name: "/temperature/success",
      component: resolve =>
        require(["@/components/temperature/success"], resolve),
      meta: {
        title: "体温申报成功"
      }
    },
    //证明打印
    {
      path: "/printproof/index",
      name: "/printproof/index",
      component: resolve => require(["@/components/printproof/index"], resolve),
      meta: {
        title: "证明打印"
      }
    },
    //无房证明
    {
      path: "/printproof/nohouse",
      name: "/printproof/nohouse",
      component: resolve =>
        require(["@/components/printproof/nohouse"], resolve),
      meta: {
        title: "家庭住房证明"
      }
    },
    {
      path: "/printproof/cxjg",
      name: "/printproof/cxjg",
      component: resolve => require(["@/components/printproof/cxjg"], resolve),
      meta: {
        title: "家庭住房证明打印"
      }
    },
    //登记簿
    {
      path: "/printproof/djb",
      name: "/printproof/djb",
      component: resolve => require(["@/components/printproof/djb"], resolve),
      meta: {
        title: "登记簿"
      }
    },
    {
      path: "/printproof/djbcxjg",
      name: "/printproof/djbcxjg",
      component: resolve =>
        require(["@/components/printproof/djbcxjg"], resolve),
      meta: {
        title: "登记簿打印"
      }
    },
    //打印记录
    {
      path: "/printproof/record",
      name: "/printproof/record",
      component: resolve =>
        require(["@/components/printproof/record"], resolve),
      meta: {
        title: "打印记录"
      }
    },
    {
      path: "/delivery/choice",
      name: "/delivery/choice",
      component: resolve => require(["@/components/delivery/choice"], resolve),
      meta: {
        title: "选择发证类型"
      }
    },
    {
      path: "/delivery/contract_cg_log",
      name: "/delivery/contract_cg_log",
      component: resolve =>
        require(["@/components/delivery/contract_cg_log"], resolve),
      meta: {
        title: "新建商品房网签交易合同(常规版)"
      }
    },
    {
      path: "/delivery/contract_cg_detail",
      name: "/delivery/contract_cg_detail",
      component: resolve =>
        require(["@/components/delivery/contract_cg_detail"], resolve),
      meta: {
        title: "交房即发证申请(常规版)"
      }
    },
    {
      path: "/delivery/contract_cg_edit",
      name: "/delivery/contract_cg_edit",
      component: resolve =>
        require(["@/components/delivery/contract_cg_edit"], resolve),
      meta: {
        title: "交房即发证编辑"
      }
    },
    {
      path: "/delivery/cg_log",
      name: "/delivery/cg_log",
      component: resolve => require(["@/components/delivery/cg_log"], resolve),
      meta: {
        title: "交房即发证申请记录"
      }
    },
    {
      path: "/delivery/yycg",
      name: "/delivery/yycg",
      component: resolve => require(["@/components/delivery/yycg"], resolve),
      meta: {
        title: "申请成功"
      }
    },
    {
      path: "/delivery/contract_log",
      name: "/delivery/contract_log",
      component: resolve =>
        require(["@/components/delivery/contract_log"], resolve),
      meta: {
        title: "新建商品房网签交易合同(现场版)"
      }
    },
    {
      path: "/delivery/contract_detail",
      name: "/delivery/contract_detail",
      component: resolve =>
        require(["@/components/delivery/contract_detail"], resolve),
      meta: {
        title: "交房即发证申请(现场版)"
      }
    },
    {
      path: "/delivery/contract_edit",
      name: "/delivery/contract_edit",
      component: resolve =>
        require(["@/components/delivery/contract_edit"], resolve),
      meta: {
        title: "交房即发证编辑"
      }
    },
    {
      path: "/delivery/success",
      name: "/delivery/success",
      component: resolve => require(["@/components/delivery/success"], resolve),
      meta: {
        title: "操作成功"
      }
    },
    {
      path: "/delivery/view",
      name: "/delivery/view",
      component: resolve => require(["@/components/delivery/view"], resolve),
      meta: {
        title: "交房即发证查看"
      }
    },
    {
      path: "/delivery/view_cg",
      name: "/delivery/view_cg",
      component: resolve => require(["@/components/delivery/view_cg"], resolve),
      meta: {
        title: "交房即发证查看"
      }
    },
    {
      path: "/delivery/log",
      name: "/delivery/log",
      component: resolve => require(["@/components/delivery/log"], resolve),
      meta: {
        title: "交房即发证申请记录"
      }
    },
    {
      path: "/delivery/view",
      name: "/delivery/view",
      component: resolve => require(["@/components/delivery/view"], resolve),
      meta: {
        title: "交房即发证查看"
      }
    },
    {
      path: "/transfer/choice",
      name: "/transfer/choice",
      component: resolve => require(["@/components/transfer/choice"], resolve),
      meta: {
        title: "一键过户"
      }
    },
    {
      path: "/transfer/water/house",
      name: "/transfer/water/house",
      component: resolve =>
        require(["@/components/transfer/water/house"], resolve),
      meta: {
        title: "水务过户"
      }
    },
    {
      path: "/transfer/water/confirm",
      name: "/transfer/water/confirm",
      component: resolve =>
        require(["@/components/transfer/water/confirm"], resolve),
      meta: {
        title: "填写材料"
      }
    },
    {
      path: "/transfer/water/success",
      name: "/transfer/water/success",
      component: resolve =>
        require(["@/components/transfer/water/success"], resolve),
      meta: {
        title: "操作结果"
      }
    },
    {
      path: "/transfer/water/log",
      name: "/transfer/water/log",
      component: resolve =>
        require(["@/components/transfer/water/log"], resolve),
      meta: {
        title: "过户记录"
      }
    },
    {
      path: "/transfer/electricity/house",
      name: "/transfer/electricity/house",
      component: resolve =>
        require(["@/components/transfer/electricity/house"], resolve),
      meta: {
        title: "电力过户"
      }
    },
    {
      path: "/transfer/electricity/success",
      name: "/transfer/electricity/success",
      component: resolve =>
        require(["@/components/transfer/electricity/success"], resolve),
      meta: {
        title: "电力过户"
      }
    },
    {
      path: "/transfer/electricity/log",
      name: "/transfer/electricity/log",
      component: resolve =>
        require(["@/components/transfer/electricity/log"], resolve),
      meta: {
        title: "电力过户"
      }
    },
    {
      path: "/transfer/electricity/bind",
      name: "/transfer/electricity/bind",
      component: resolve =>
        require(["@/components/transfer/electricity/bind"], resolve),
      meta: {
        title: "电力过户"
      }
    },
    {
      path: "/transfer/electricity/confirm",
      name: "/transfer/electricity/confirm",
      component: resolve =>
        require(["@/components/transfer/electricity/confirm"], resolve),
      meta: {
        title: "填写材料"
      }
    },
    {
      path: "/transfer/electricity/card",
      name: "/transfer/electricity/card",
      component: resolve =>
        require(["@/components/transfer/electricity/card"], resolve),
      meta: {
        title: "填写材料"
      }
    },
    {
      path: "/transfer/gas/house",
      name: "/transfer/gas/house",
      component: resolve =>
        require(["@/components/transfer/gas/house"], resolve),
      meta: {
        title: "燃气过户"
      }
    },
    {
      path: "/transfer/gas/confirm",
      name: "/transfer/gas/confirm",
      component: resolve =>
        require(["@/components/transfer/gas/confirm"], resolve),
      meta: {
        title: "填写材料"
      }
    },

    {
      path: "/transfer/gas/agreement",
      name: "/transfer/gas/agreement",
      component: resolve =>
        require(["@/components/transfer/gas/agreement"], resolve),
      meta: {
        title: "用户协议"
      }
    },
    {
      path: "/transfer/gas/yhcn",
      name: "/transfer/gas/yhcn",
      component: resolve =>
        require(["@/components/transfer/gas/yhcn"], resolve),
      meta: {
        title: "用户承诺"
      }
    },
    {
      path: "/transfer/gas/signature",
      name: "/transfer/gas/signature",
      component: resolve =>
        require(["@/components/transfer/gas/signature"], resolve),
      meta: {
        title: "电子签名"
      }
    },

    {
      path: "/transfer/gas/confirmMessage",
      name: "/transfer/gas/confirmMessage",
      component: resolve =>
        require(["@/components/transfer/gas/confirmMessage"], resolve),
      meta: {
        title: "电子签名"
      }
    },

    {
      path: "/transfer/gas/edit",
      name: "/transfer/gas/edit",
      component: resolve =>
        require(["@/components/transfer/gas/edit"], resolve),
      meta: {
        title: "材料补充"
      }
    },
    {
      path: "/transfer/gas/success",
      name: "/transfer/gas/success",
      component: resolve =>
        require(["@/components/transfer/gas/success"], resolve),
      meta: {
        title: "操作结果"
      }
    },
    {
      path: "/transfer/gas/log",
      name: "/transfer/gas/log",
      component: resolve => require(["@/components/transfer/gas/log"], resolve),
      meta: {
        title: "过户记录"
      }
    },
    {
      path: "/e_handbook/e_index",
      name: "/e_handbook/e_index",
      component: resolve =>
        require(["@/components/e_handbook/e_index"], resolve),
      meta: {
        title: "e 指南"
      }
    },
    {
      path: "/e_handbook/indexM",
      name: "/e_handbook/indexM",
      component: resolve =>
        require(["@/components/e_handbook/indexM"], resolve),
      meta: {
        title: "不动产登记"
      }
    },
    {
      path: "/e_handbook/clfdj",
      name: "/e_handbook/clfdj",
      component: resolve => require(["@/components/e_handbook/clfdj"], resolve),
      meta: {
        title: "查看详情"
      }
    },
    {
      path: "/e_handbook/sfbz",
      name: "/e_handbook/sfbz",
      component: resolve => require(["@/components/e_handbook/sfbz"], resolve),
      meta: {
        title: "收费标准"
      }
    },
    {
      path: "/e_handbook/excel",
      name: "/e_handbook/excel",
      component: resolve => require(["@/components/e_handbook/excel"], resolve),
      meta: {
        title: "查看表格"
      }
    },
    {
      path: "/e_handbook/sjcl",
      name: "/e_handbook/sjcl",
      component: resolve => require(["@/components/e_handbook/sjcl"], resolve),
      meta: {
        title: "收件材料"
      }
    },
    {
      path: "/e_handbook/sjcl_detail",
      name: "/e_handbook/sjcl_detail",
      component: resolve =>
        require(["@/components/e_handbook/sjcl_detail"], resolve),
      meta: {
        title: "材料详情"
      }
    },
    {
      path: "/asset/house/dzzzDetail",
      name: "/asset/house/dzzzDetail",
      component: resolve =>
        require(["@/components/asset/house/dzzzDetail.vue"], resolve),
      meta: {
        title: "电子证照"
      }
    },

    {
      path: "/asset/index",
      name: "/template/atabbar",
      component: resolve =>
        require(["@/components/template/atabbar.vue"], resolve),
      redirect: "/asset/myasset",
      children: [
        {
          path: "/asset/myasset",
          name: "/asset/myasset",
          component: resolve =>
            require(["@/components/asset/house/myasset.vue"], resolve),
          meta: {
            title: "我的房产"
          }
        },
        {
          path: "/asset/chatList",
          name: "/asset/chatList",
          component: resolve =>
            require(["@/components/asset/chat/chatList.vue"], resolve),
          meta: {
            title: "聊天"
          }
        }
      ]
    },
    {
      path: "/asset/chat/:toName",
      name: "/asset/chat",
      component: resolve =>
        require(["@/components/asset/chat/chat.vue"], resolve),
      meta: {
        title: "聊天室"
      }
    },
    {
      path: "/asset/mycommunity",
      name: "/asset/mycommunity",
      component: resolve =>
        require(["@/components/asset/house/mycommunity.vue"], resolve),
      meta: {
        title: "小区信息"
      }
    },
    {
      path: "/asset/sellInfo",
      name: "/asset/sellInfo",
      component: resolve =>
        require(["@/components/asset/house/sellInfo.vue"], resolve),
      meta: {
        title: "我要晒房"
      }
    },
    {
      path: "/asset/infoList",
      name: "/asset/infoList",
      component: resolve =>
        require(["@/components/asset/house/infoList.vue"], resolve),
      meta: {
        title: "发布列表"
      }
    },
    {
      path: "/asset/myinfoList",
      name: "/asset/myinfoList",
      component: resolve =>
        require(["@/components/asset/house/myinfoList.vue"], resolve),
      meta: {
        title: "我的发布"
      }
    },
    {
      path: "/asset/community",
      name: "/asset/community",
      component: resolve =>
        require(["@/components/asset/house/community.vue"], resolve),
      meta: {
        title: "小区",
        keepAlive: true
      }
    },
    {
      path: "/asset/sellView",
      name: "/asset/sellView",
      component: resolve =>
        require(["@/components/asset/house/sellView.vue"], resolve),
      meta: {
        title: "晒房详情",
        keepAlive: true
      }
    },
    {
      path: "/asset/sellView/:sell_id",
      name: "/asset/sellView",
      component: resolve =>
        require(["@/components/asset/house/sellView.vue"], resolve),
      meta: {
        title: "晒房详情"
      }
    },
    {
      path: "/asset/sellView_qt/:sell_id",
      name: "/asset/sellView_qt",
      component: resolve =>
        require(["@/components/asset/house/sellView_qt.vue"], resolve),
      meta: {
        title: "晒房详情"
      }
    },
    {
      path: "/h_query/kslp",
      name: "/h_query/kslp",
      component: resolve => require(["@/components/h_query/kslp.vue"], resolve),
      meta: {
        title: "可售楼盘"
      }
    },
    {
      path: "/h_query/kslp_detail",
      name: "/h_query/kslp_detail",
      component: resolve =>
        require(["@/components/h_query/kslp_detail.vue"], resolve),
      meta: {
        title: "可售楼盘"
      }
    },
    {
      path: "/h_query/ysxkz",
      name: "/h_query/ysxkz",
      component: resolve =>
        require(["@/components/h_query/ysxkz.vue"], resolve),
      meta: {
        title: "预售许可证查询"
      }
    },
    {
      path: "/h_query/ysxkz_detail",
      name: "/h_query/ysxkz_detail",
      component: resolve =>
        require(["@/components/h_query/ysxkz_detail.vue"], resolve),
      meta: {
        title: "预售许可证查询"
      }
    },
    {
      path: "/h_query/ksfw_query",
      name: "/h_query/ksfw_query",
      component: resolve =>
        require(["@/components/h_query/ksfw_query.vue"], resolve),
      meta: {
        title: "可售房屋查询"
      }
    },
    {
      path: "/h_query/ksfw_query_detail",
      name: "/h_query/ksfw_query_detail",
      component: resolve =>
        require(["@/components/h_query/ksfw_query_detail.vue"], resolve),
      meta: {
        title: "可售房屋查询"
      }
    },
    {
      path: "/h_query/ksfw",
      name: "/h_query/ksfw",
      component: resolve => require(["@/components/h_query/ksfw.vue"], resolve),
      meta: {
        title: "可售房屋"
      }
    },
    {
      path: "/h_query/kfqy",
      name: "/h_query/kfqy",
      component: resolve => require(["@/components/h_query/kfqy.vue"], resolve),
      meta: {
        title: "开发企业"
      }
    },
    {
      path: "/h_query/index",
      name: "/h_query/index",
      component: resolve =>
        require(["@/components/h_query/index.vue"], resolve),
      meta: {
        title: "新房预售查询"
      }
    },
    {
      path: "/h_query/zxxf_log",
      name: "/h_query/zxxf_log",
      component: resolve =>
        require(["@/components/h_query/zxxf_log.vue"], resolve),
      meta: {
        title: "在线选房日志"
      }
    },
    {
      path: "/asset/zhwy/yztp",
      name: "/asset/zhwy/yztp",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/yztp.vue"], resolve),
      meta: {
        title: "业主投票"
      }
    },
    {
      path: "/asset/zhwy/voteOptions",
      name: "/asset/zhwy/voteOptions",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/voteOptions.vue"], resolve),
      meta: {
        title: "开始投票"
      }
    },
    {
      path: "/asset/zhwy/checkVote",
      name: "/asset/zhwy/checkVote",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/checkVote.vue"], resolve),
      meta: {
        title: "查看投票"
      }
    },
    {
      path: "/asset/zhwy/addVote",
      name: "/asset/zhwy/addVote",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/addVote.vue"], resolve),
      meta: {
        title: "发布投票"
      }
    },
    {
      path: "/asset/zhwy/voteOptionsCard",
      name: "/asset/zhwy/voteOptionsCard",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/voteOptionsCard.vue"], resolve),
      meta: {
        title: "开始投票"
      }
    },
    {
      path: "/asset/zhwy/optionDetail",
      name: "/asset/zhwy/optionDetail",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/optionDetail.vue"], resolve),
      meta: {
        title: "详情"
      }
    },
    {
      path: "/asset/zhwy/votexuzhi",
      name: "/asset/zhwy/votexuzhi",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/votexuzhi.vue"], resolve),
      meta: {
        title: "投票须知"
      }
    },
    {
      path: "/asset/zhwy/voteHistory",
      name: "/asset/zhwy/voteHistory",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/voteHistory.vue"], resolve),
      meta: {
        title: "历史投票"
      }
    },
    {
      path: "/asset/zhwy/giftCode",
      name: "/asset/zhwy/giftCode",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/giftCode.vue"], resolve),
      meta: {
        title: "礼品码"
      }
    },
    {
      path: "/asset/zhwy/choice",
      name: "/asset/zhwy/choice",
      component: resolve =>
        require(["@/components/asset/zhwy/choice.vue"], resolve),
      meta: {
        title: "智慧物业"
      }
    },
    {
      path: "/asset/zhwy/giftList",
      name: "/asset/zhwy/giftList",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/giftList.vue"], resolve),
      meta: {
        title: "我的礼品"
      }
    },
    {
      path: "/asset/zhwy/hxHistory",
      name: "/asset/zhwy/hxHistory",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/hxHistory.vue"], resolve),
      meta: {
        title: "已核销"
      }
    },
    {
      path: "/asset/zhwy/mypush",
      name: "/asset/zhwy/mypush",
      component: resolve =>
        require(["@/components/asset/zhwy/vote/mypush.vue"], resolve),
      meta: {
        title: "我的发布"
      }
    },
    {
      path: "/apply/choicebdc/:type",
      name: "/apply/choicebdc",
      component: resolve =>
        require(["@/components/apply/choicebdc.vue"], resolve),
      meta: {
        title: "填写抵押信息"
      }
    },
    {
      path: "/apply/01/mainUpload",
      name: "/apply/01/mainUpload",
      component: resolve =>
        require(["@/components/apply/01/mainUpload.vue"], resolve),
      meta: {
        title: "抵押申请"
      }
    },
    {
      path: "/apply/01/editUpload",
      name: "/apply/01/editUpload",
      component: resolve =>
        require(["@/components/apply/01/editUpload.vue"], resolve),
      meta: {
        title: "编辑"
      }
    },
    {
      path: "/apply/02/mainUpload",
      name: "/apply/02/mainUpload",
      component: resolve =>
        require(["@/components/apply/02/mainUpload.vue"], resolve),
      meta: {
        title: "抵押注销申请"
      }
    },
    {
      path: "/apply/02/editUpload",
      name: "/apply/02/editUpload",
      component: resolve =>
        require(["@/components/apply/02/editUpload.vue"], resolve),
      meta: {
        title: "编辑"
      }
    },
    {
      path: "/apply/01/log",
      name: "/apply/01/log",
      component: resolve => require(["@/components/apply/01/log.vue"], resolve),
      meta: {
        title: "抵押日志"
      }
    },
    {
      path: "/apply/01/view",
      name: "/apply/01/view",
      component: resolve =>
        require(["@/components/apply/01/view.vue"], resolve),
      meta: {
        title: "抵押详情"
      }
    },
    {
      path: "/apply/02/log",
      name: "/apply/02/log",
      component: resolve => require(["@/components/apply/02/log.vue"], resolve),
      meta: {
        title: "抵押注销日志"
      }
    },
    {
      path: "/apply/02/view",
      name: "/apply/02/view",
      component: resolve =>
        require(["@/components/apply/02/view.vue"], resolve),
      meta: {
        title: "抵押注销详情"
      }
    },
    {
      path: "/apply/01/dbList",
      name: "/apply/01/dbList",
      component: resolve =>
        require(["@/components/apply/01/dbList.vue"], resolve),
      meta: {
        title: "待办列表"
      }
    },
    {
      path: "/apply/01/ybList",
      name: "/apply/01/ybList",
      component: resolve =>
        require(["@/components/apply/01/ybList.vue"], resolve),
      meta: {
        title: "已办列表"
      }
    },
    {
      path: "/apply/01/shenpi",
      name: "/apply/01/shenpi",
      component: resolve =>
        require(["@/components/apply/01/shenpi.vue"], resolve),
      meta: {
        title: "抵押预审"
      }
    },
    {
      path: "/apply/01/viewSp",
      name: "/apply/01/viewSp",
      component: resolve =>
        require(["@/components/apply/01/viewSp.vue"], resolve),
      meta: {
        title: "初审信息"
      }
    },
    {
      path: "/doubletralier/onlinecontract",
      name: "/doubletralier/onlinecontract",
      component: resolve =>
        require(["@/components/doubleTrailer/onlineContractList.vue"], resolve),
      meta: {
        title: "网签合同列表"
      }
    },
    {
      path: "/doubletralier/doublepreviewlist",
      name: "/doubletralier/doublepreviewlist",
      component: resolve =>
        require(["@/components/doubleTrailer/doublePreviewList.vue"], resolve),
      meta: {
        title: "双预告申请"
      }
    },
    {
      path: "/doubletralier/checkdeclaration",
      name: "/doubletralier/checkdeclaration",
      component: resolve =>
        require(["@/components/doubleTrailer/checkDeclaration.vue"], resolve),
      meta: {
        title: "申报历史"
      }
    },
    {
      path: "/doubletralier/checkTurnDeclaration",
      name: "/doubletralier/checkTurnDeclaration",
      component: resolve =>
        require([
          "@/components/doubleTrailer/checkTurnDeclaration.vue"
        ], resolve),
      meta: {
        title: "申报历史"
      }
    },
    {
      path: "/doubletralier/commercialhousing",
      name: "/doubletralier/commercialhousing",
      component: resolve =>
        require(["@/components/doubleTrailer/commercialHousing.vue"], resolve),
      meta: {
        title: "预购商品房预告登记"
      }
    },
    {
      path: "/doubletralier/turnadvance",
      name: "/doubletralier/turnadvance",
      component: resolve =>
        require(["@/components/doubleTrailer/turnAdvance.vue"], resolve),
      meta: {
        title: "预转本登记"
      }
    },
    {
      path: "/doubletralier/advanceregistration",
      name: "/doubletralier/advanceregistration",
      component: resolve =>
        require([
          "@/components/doubleTrailer/advanceRegistration.vue"
        ], resolve),
      meta: {
        title: "预转本登记"
      }
    },
    {
      path: "/doubletralier/turnCommercialHousing",
      name: "/doubletralier/turnCommercialHousing",
      component: resolve =>
        require([
          "@/components/doubleTrailer/turnCommercialHousing.vue"
        ], resolve),
      meta: {
        title: "预转本登记"
      }
    },
    // 维修资金缴存
    {
      path: "/wxjc/choice",
      name: "/wxjc/choice",
      component: resolve => require(["@/components/wxjc/choice.vue"], resolve),
      meta: {
        title: "我的房子"
      }
    },
    {
      path: "/wxjc/houseInfo",
      name: "/wxjc/houseInfo",
      component: resolve =>
        require(["@/components/wxjc/houseInfo.vue"], resolve),
      meta: {
        title: "查询缴存情况（苏州银行）"
      }
    },
    {
      path: "/wxjc/houseInfo_Gs",
      name: "/wxjc/houseInfo_Gs",
      component: resolve =>
        require(["@/components/wxjc/houseInfo_Gs.vue"], resolve),
      meta: {
        title: "查询缴存情况（工商银行）"
      }
    },
    {
      path: "/wxjc/choicefw",
      name: "/wxjc/choicefw",
      component: resolve =>
        require(["@/components/wxjc/choicefw.vue"], resolve),
      meta: {
        title: "我的维修资金"
      }
    },
    {
      path: "/wxjc/maintenanceFunds",
      name: "/wxjc/maintenanceFunds",
      component: resolve =>
        require(["@/components/wxjc/maintenanceFunds.vue"], resolve),
      meta: {
        title: "维修资金"
      }
    },
    {
      path: "/wxjc/maintenancefundstype",
      name: "maintenancefundstype",
      component: resolve =>
        require(["@/components/wxjc/maintenanceFundsType.vue"], resolve),
      meta: {
        title: "维修资金"
      }
    },
    {
      path: "/wxjc/maintenancefundsquery",
      name: "maintenancefundsquery",
      component: resolve =>
        require(["@/components/wxjc/maintenanceFundsQuery.vue"], resolve),
      meta: {
        title: "维修资金"
      }
    },
    {
      path: "/wxjc/maintenancefundsdeatils",
      name: "maintenancefundsdeatils",
      component: resolve =>
        require(["@/components/wxjc/maintenanceFundsDeatils.vue"], resolve),
      meta: {
        title: "维修资金"
      }
    },
    {
      path: "/wxjc/gsPayZt",
      name: "gsPayZt",
      component: resolve => require(["@/components/wxjc/gsPayZt.vue"], resolve),
      meta: {
        title: "工商银行缴款状态"
      }
    },
    {
      path: "/wxjc/maintenancefundspaylog",
      name: "maintenancefundspaylog",
      component: resolve =>
        require([
          "@/components/wxjc/maintenancefundspaylog/index.vue"
        ], resolve),
      meta: {
        title: "缴费记录"
      }
    },
    {
      path: "/query/dacx/dacxType",
      name: "dacxType",
      component: resolve =>
        require(["@/components/query/dacx/dacxType.vue"], resolve),
      meta: {
        title: "档案查询"
      }
    },
    {
      path: "/query/dacx/choicebdc",
      name: "dacxchoicebdc",
      component: resolve =>
        require(["@/components/query/dacx/dacxchoicebdc.vue"], resolve),
      meta: {
        title: "档案查询"
      }
    },
    {
      path: "/query/dacx/dacx",
      name: "/query/dacx/dacx",
      component: resolve =>
        require(["@/components/query/dacx/dacx.vue"], resolve),
      meta: {
        title: "档案列表"
      }
    },
    {
      path: "/query/dacx/dacxDetail",
      name: "dacx",
      component: resolve =>
        require(["@/components/query/dacx/dacx_detail.vue"], resolve),
      meta: {
        title: "档案详情"
      }
    },
    // 防疫采样记录
    {
      path: "/tpersonmodel/checkLd",
      name: "/tpersonmodel/checkLd",
      component: resolve =>
        require(["@/components/tpersonmodel/checkLd/index.vue"], resolve),
      meta: {
        title: "选择小区楼幢"
      }
    },
    {
      path: "/tpersonmodel/checkHh",
      name: "/tpersonmodel/checkHh",
      component: resolve =>
        require(["@/components/tpersonmodel/checkHh/index.vue"], resolve),
      meta: {
        title: "选择户号"
      }
    },
    {
      path: "/tpersonmodel/confirmRy",
      name: "/tpersonmodel/confirmRy",
      component: resolve =>
        require(["@/components/tpersonmodel/confirmRy/index.vue"], resolve),
      meta: {
        title: "确认添加采样人员"
      }
    },
    {
      path: "/wqht/choice",
      name: "/wqht/choice",
      component: resolve => require(["@/components/wqht/choice.vue"], resolve),
      meta: {
        title: "合同类型选择"
      }
    },
    {
      path: "/wqht/xfChoice",
      name: "/wqht/xfChoice",
      component: resolve =>
        require(["@/components/wqht/xfChoice.vue"], resolve),
      meta: {
        title: "新房合同"
      }
    },
    {
      path: "/wqht/clfChoice",
      name: "/wqht/clfChoice",
      component: resolve =>
        require(["@/components/wqht/clfChoice.vue"], resolve),
      meta: {
        title: "存量房合同"
      }
    },
    {
      path: "/wqht/clfHtList",
      name: "/wqht/clfHtList",
      component: resolve =>
        require(["@/components/wqht/clfHtList.vue"], resolve),
      meta: {
        title: "存量房合同"
      }
    },
    {
      path: "/wqht/clfHtInfo",
      name: "/wqht/clfHtInfo",
      component: resolve =>
        require(["@/components/wqht/clfHtInfo.vue"], resolve),
      meta: {
        title: "合同详情"
      }
    },
    {
      path: "/wqht/htList",
      name: "/wqht/htList",
      component: resolve => require(["@/components/wqht/htList.vue"], resolve),
      meta: {
        title: "网签合同"
      }
    },
    {
      path: "/wqht/htInfo",
      name: "/wqht/htInfo",
      component: resolve => require(["@/components/wqht/htInfo.vue"], resolve),
      meta: {
        title: "合同详情"
      }
    },
    {
      path: "/wqht/scan",
      name: "/wqht/scan",
      component: resolve => require(["@/components/wqht/scan.vue"], resolve),
      meta: {
        title: "备案信息"
      }
    },
    {
      path: "/wqht/check",
      name: "/wqht/check",
      component: resolve => require(["@/components/wqht/check.vue"], resolve),
      meta: {
        title: "合同验证"
      }
    },
    {
      path: "/wqht/checkHtInfo",
      name: "/wqht/checkHtInfo",
      component: resolve =>
        require(["@/components/wqht/checkHtInfo.vue"], resolve),
      meta: {
        title: "验证详情"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js